export default __webpack_public_path__ + "static/media/logomicyd.5f97a3bc.svg";